import * as React from "react"
import { ConnectContentfulSpaceForm } from "../../edition/components/ConnectContentfulSpaceForm"
import { ConnectCosmicJSForm } from "../../edition/components/ConnectCosmicJSForm"
import { ConnectDatoCmsForm } from "../../edition/components/ConnectDatoCmsForm"
import { ConnectSanityForm } from "../../edition/components/ConnectSanityForm"
import { CmsVendor } from "@modules/graphql/types"
import { ErrorAlert } from "@modules/ui/components/ErrorAlert"
import { ConnectShopifyForm } from "@modules/cms/edition/components/ConnectShopifyForm"
import { OnboardingSiteType } from "@modules/onboarding/shared/types"

export type CmsIntegrationFormProps = {
  siteId: string
  siteName: string
  siteType: OnboardingSiteType
  cmsVendor: CmsVendor
  onComplete: () => void
  onCancel: () => void
  onFetchError: () => void
}

export function CmsIntegrationForm({
  siteId,
  siteName,
  siteType,
  cmsVendor,
  onComplete,
  onFetchError,
  onCancel,
}: CmsIntegrationFormProps) {
  const FormComponent = getConnectCmsComponent(cmsVendor)

  if (!FormComponent) {
    return <ErrorAlert>Unable to connect</ErrorAlert>
  }

  return (
    <FormComponent
      siteId={siteId}
      siteName={siteName}
      siteType={siteType}
      onCancel={onCancel}
      onComplete={onComplete}
      onFetchError={onFetchError}
    />
  )
}

function getConnectCmsComponent(cmsVendor: CmsVendor) {
  switch (cmsVendor) {
    case CmsVendor.Contentful:
      return ConnectContentfulSpaceForm
    case CmsVendor.Cosmicjs:
      return ConnectCosmicJSForm
    case CmsVendor.Datocms:
      return ConnectDatoCmsForm
    case CmsVendor.Sanity:
      return ConnectSanityForm
    case CmsVendor.Shopify:
      return ConnectShopifyForm
    default:
      return null
  }
}
